import React from 'react';
import { Breadcrumbs } from '@ocm_customer/account_navigation';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Typography } from '@one-thd/sui-atomic-components';

function Header() {
  const crumbs = useAccountCrumbs([
    {
      label: 'Communication Preferences',
    },
  ]);

  return (
    <div className="sui-grid sui-gap-4">
      <Breadcrumbs crumbs={crumbs} />
      <Typography variant="h1" weight="display">COMMUNICATION PREFERENCES</Typography>
    </div>
  );
}

export default Header;
